document.addEventListener("DOMContentLoaded", function(event) {
    pageLoaded();
    
    setOffsetMp();
    menuAgil();
});


// WP AND BODY OFFSET WITH MENU PRINCIPAL FIXED TOP
const wpAdminBar = document.querySelector('#wpadminbar') || 0;
const headerFixed = document.querySelector('.header-template.fixed-top');
const bodyTemplate = document.querySelector('body');

bodyTemplate.classList.add('stop-scrolling');

const pageLoaded = () =>{
    setTimeout(() => {
        let loaderSection = document.querySelector('.load-content');
        loaderSection.classList.add('loaded');
        bodyTemplate.classList.remove('stop-scrolling');
    }, 1000);
    // }, 0);
}

const setOffsetMp = () => {
    if(window.innerWidth > 600){
        if(wpAdminBar && window.scrollY < headerFixed.offsetHeight){
            headerFixed.setAttribute('style',`top: ${wpAdminBar.offsetHeight}px`);
            bodyTemplate.setAttribute('style',`margin-top: ${headerFixed.offsetHeight}px`);
        }
        else{
            headerFixed.setAttribute('style',`top: ${wpAdminBar.offsetHeight}px`);
            bodyTemplate.setAttribute('style',`margin-top: ${headerFixed.offsetHeight}px`);
        }
    }
    else{
        if(wpAdminBar && window.scrollY < headerFixed.offsetHeight){
            headerFixed.setAttribute('style',`top: ${wpAdminBar.offsetHeight}px`);
            bodyTemplate.setAttribute('style',`margin-top: ${headerFixed.offsetHeight}px`);
        }
        else{
            headerFixed.setAttribute('style',`top: 0px`);
            bodyTemplate.setAttribute('style',`margin-top: ${headerFixed.offsetHeight}px`);
        }
    }
}

window.addEventListener('scroll', () => {
    setOffsetMp();
    collapseInstMp1.hide();
});

window.addEventListener('resize', () => {
    setOffsetMp();
});


// // MENU PRINCIPAL SCRIPTING
const menuPrincipal = document.querySelector('#menuPrincipal');
const iconMenu = document.querySelector('#icon-menu');

// // COLLAPSE MENU PRINCIPAL
const collapseMp1 = document.querySelector('#collapseMp1');

// CUSTOM BTN
const btnCollapseMp1 = document.querySelector('#btnCollapseMp1');

const btnCollapseIconMp1 = document.querySelector('#btnCollapseMp1 span i');


// INSTANCIAS MENU PRINCIPAL
const collapseInstMp1 = new bootstrap.Collapse('#collapseMp1', {
    toggle: false,
    show: false,
    hide: false
});

// // CERRAR MENU ICON
const iconCerrarMenu = () => {
    iconMenu.classList.remove('icon-menu-dots');
    iconMenu.classList.add('icon-close');
}

// // MOSTRAR MENU ICON
const iconMostrarMenu = () => {
    iconMenu.classList.remove('icon-close');
    iconMenu.classList.add('icon-menu-dots');
}

// // MENU PRINCIPAL EVENTOS
menuPrincipal.addEventListener('show.bs.collapse', (event) => {
    if(event.target.id === menuPrincipal.id){
        iconCerrarMenu();

        bodyTemplate.classList.add('stop-scrolling');
    }
    else{
        return false;
    }
});
menuPrincipal.addEventListener('hide.bs.collapse', (event) => {
    if(event.target.id === menuPrincipal.id){
        iconMostrarMenu();

        bodyTemplate.classList.remove('stop-scrolling');
    }
    else{
        return false;
    }
});

menuPrincipal.addEventListener('hidden.bs.collapse', (event) => {
    // console.log(event);
    if(event.target.id === menuPrincipal.id){
        btnCollapseMp1.classList.remove('active');

        btnCollapseIconMp1.classList.remove('icon-arrow-up');
        btnCollapseIconMp1.classList.add('icon-arrow-down');

        collapseInstMp1.hide();
    }
    else{
        return false;
    }
});

// COLLAPSE MENU PRINCIPAL TRANSICIONES
collapseMp1.addEventListener('show.bs.collapse', (event) => {
    if(event.target.id === collapseMp1.id){
        btnCollapseMp1.classList.add('active');

        btnCollapseIconMp1.classList.remove('icon-arrow-down');
        btnCollapseIconMp1.classList.add('icon-arrow-up');
    }
    else{
        return false;
    }
});
collapseMp1.addEventListener('hide.bs.collapse', (event) => {
    if(event.target.id === collapseMp1.id){
        btnCollapseMp1.classList.remove('active');

        btnCollapseIconMp1.classList.remove('icon-arrow-up');
        btnCollapseIconMp1.classList.add('icon-arrow-down');
    }
    else{
        return false;
    }
});


// MOUSEOVER AND MOUSELEAVE COLLAPSE TRANSITIONS
btnCollapseMp1.addEventListener('mouseover', () => {
    collapseInstMp1.show();
});
btnCollapseMp1.parentElement.addEventListener('mouseleave', () => {
    collapseInstMp1.hide();
});


// // MENU AGIL
const menuAgil = () => {
    const btnMenuAgil = document.querySelector('#btn-menu-agil');
    const collapseMenuAgil = document.querySelector('#collapseMenuAgil');

    collapseMenuAgil.addEventListener('show.bs.collapse', () => {
        btnMenuAgil.classList.add('d-none');
    });

    collapseMenuAgil.addEventListener('hide.bs.collapse', () => {
        btnMenuAgil.classList.remove('d-none');
    });
}

